<template>
  <div class="y4-history-page">
    <div class="page-toolbar">
      <div>
        <h2>Y4授权历史数据</h2>
        <span>DY_Y4</span>
      </div>
      <el-button size="mini" icon="el-icon-refresh" :loading="loading" @click="queryData">刷新</el-button>
    </div>

    <section class="query-section">
      <div class="query-bar">
        <span class="field-label">游戏</span>
        <el-select
            v-model="queryGame"
            size="mini"
            filterable
            clearable
            placeholder="游戏选择"
            style="width: 260px">
          <el-option
              v-for="game in myGames"
              :key="game"
              :label="game"
              :value="game">
          </el-option>
        </el-select>

        <span class="field-label">计算日期</span>
        <el-date-picker
            v-model="calcDate"
            type="date"
            size="mini"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            :picker-options="pickerOptions"
            style="width: 150px">
        </el-date-picker>

        <el-button
            size="mini"
            type="primary"
            icon="el-icon-search"
            :loading="loading"
            :disabled="!calcDate || myGames.length === 0"
            @click="queryData">
          查询
        </el-button>

        <el-tag size="mini" :type="myAllGame ? 'success' : 'warning'">{{ permissionLabel }}</el-tag>
      </div>
    </section>

    <el-alert
        v-if="myGames.length === 0"
        title="当前账号暂无可见游戏"
        type="warning"
        :closable="false"
        show-icon>
    </el-alert>

    <el-tabs v-model="activeTab" class="matrix-tabs">
      <el-tab-pane label="不带预估" name="raw"></el-tab-pane>
      <el-tab-pane label="带预估" name="estimated"></el-tab-pane>
    </el-tabs>

    <section v-loading="loading" class="matrix-section">
      <div v-if="activeBlocks.length === 0" class="empty-state">暂无数据</div>
      <div v-else class="matrix-scroll">
        <table class="history-table">
          <tbody
              v-for="block in activeBlocks"
              :key="activeTab + '-' + block.gameName"
              class="game-block">
          <tr class="block-head">
            <td class="game-cell" rowspan="6">{{ block.gameName }}</td>
            <td class="target-cell"></td>
            <td class="history-head">历史数据</td>
            <td v-for="date in displayDates" :key="'head-' + block.gameName + '-' + date" class="date-head">
              {{ displayDate(date) }}
            </td>
          </tr>
          <tr>
            <td class="metric-label">消耗</td>
            <td class="history-value">{{ formatMoney(block.history && block.history.totalCost) }}</td>
            <td v-for="date in displayDates" :key="'cost-' + block.gameName + '-' + date">
              {{ formatMoney(dateCell(block, date).statCost) }}
            </td>
          </tr>
          <tr>
            <td class="metric-label">{{ periodLabel(block) }}</td>
            <td class="history-value">{{ formatRoiRate(block.history && block.history.roi, block.history && block.history.rate) }}</td>
            <td v-for="date in displayDates" :key="'period-' + block.gameName + '-' + date">
              <template v-if="hasRoiRate(dateCell(block, date).periodRoi, dateCell(block, date).periodRate)">
                <span :class="valueClass(dateCell(block, date).periodRoi, block.history && block.history.roi, date, dateCell(block, date).period)">
                  {{ formatPercent(dateCell(block, date).periodRoi) }}
                </span>
                <span> | </span>
                <span :class="valueClass(dateCell(block, date).periodRate, block.history && block.history.rate, date, dateCell(block, date).period)">
                  {{ formatRate(dateCell(block, date).periodRate) }}
                </span>
              </template>
              <span v-else>-</span>
            </td>
          </tr>
          <tr>
            <td class="metric-label">7日ROI | 倍率</td>
            <td class="history-value">{{ formatRoiRate(block.history && block.history.roi7, block.history && block.history.roi7Rate) }}</td>
            <td v-for="date in displayDates" :key="'roi7-' + block.gameName + '-' + date">
              <template v-if="hasRoiRate(dateCell(block, date).roi7, dateCell(block, date).roi7Rate)">
                <span :class="valueClass(dateCell(block, date).roi7, block.history && block.history.roi7, date, 7)">
                  {{ formatPercent(dateCell(block, date).roi7) }}
                </span>
                <span> | </span>
                <span :class="valueClass(dateCell(block, date).roi7Rate, block.history && block.history.roi7Rate, date, 7)">
                  {{ formatRate(dateCell(block, date).roi7Rate) }}
                </span>
              </template>
              <span v-else>-</span>
            </td>
          </tr>
          <tr>
            <td class="metric-label">3日ROI | 倍率</td>
            <td class="history-value">{{ formatRoiRate(block.history && block.history.roi3, block.history && block.history.roi3Rate) }}</td>
            <td v-for="date in displayDates" :key="'roi3-' + block.gameName + '-' + date">
              <template v-if="hasRoiRate(dateCell(block, date).roi3, dateCell(block, date).roi3Rate)">
                <span :class="valueClass(dateCell(block, date).roi3, block.history && block.history.roi3, date, 3)">
                  {{ formatPercent(dateCell(block, date).roi3) }}
                </span>
                <span> | </span>
                <span :class="valueClass(dateCell(block, date).roi3Rate, block.history && block.history.roi3Rate, date, 3)">
                  {{ formatRate(dateCell(block, date).roi3Rate) }}
                </span>
              </template>
              <span v-else>-</span>
            </td>
          </tr>
          <tr>
            <td class="metric-label">1日ROI</td>
            <td class="history-value">{{ formatPercent(block.history && block.history.roi1) }}</td>
            <td v-for="date in displayDates" :key="'roi1-' + block.gameName + '-' + date">
              <span :class="valueClass(dateCell(block, date).roi1, block.history && block.history.roi1, date, 1)">
                {{ formatPercent(dateCell(block, date).roi1) }}
              </span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ToufangY4HistoryMatrix',
  data() {
    return {
      activeTab: 'raw',
      myAllGame: false,
      myGames: [],
      queryGame: '',
      calcDate: '',
      displayDates: [],
      rawBlocks: [],
      estimatedBlocks: [],
      loading: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  computed: {
    activeBlocks() {
      return this.activeTab === 'estimated' ? this.estimatedBlocks : this.rawBlocks
    },
    permissionLabel() {
      return this.myAllGame ? '全部游戏' : this.myGames.length + ' 个游戏'
    }
  },
  mounted() {
    this.calcDate = this.defaultCalcDate()
    this.loadMyGames().then(() => {
      if (this.myGames.length > 0) {
        this.queryData()
      }
    })
  },
  methods: {
    async loadMyGames() {
      try {
        const response = await this.$axios.get('/toufang/gamePermission/myGames')
        const data = response.data.data || {}
        this.myAllGame = !!data.allGame
        this.myGames = data.games || []

        if (this.queryGame && !this.myGames.includes(this.queryGame)) {
          this.queryGame = ''
        }
      } catch (error) {
        this.myAllGame = false
        this.myGames = []
      }
    },
    async queryData() {
      if (!this.calcDate) {
        this.$message.warning('请选择计算日期')
        return
      }

      this.loading = true
      try {
        const response = await this.$axios.post('/toufang/data/findY4HistoryMatrixByPermission', {
          cname: this.queryGame || '',
          calcDate: this.calcDate
        })

        if (response.data.success) {
          const data = response.data.data || {}
          this.displayDates = data.displayDates || this.buildDisplayDates(this.calcDate)
          this.rawBlocks = data.rawBlocks || []
          this.estimatedBlocks = data.estimatedBlocks || []
        } else {
          this.clearData()
          this.$message.error(response.data.msg || '查询失败')
        }
      } catch (error) {
        this.clearData()
        this.$message.error('查询失败')
      } finally {
        this.loading = false
      }
    },
    clearData() {
      this.displayDates = this.buildDisplayDates(this.calcDate)
      this.rawBlocks = []
      this.estimatedBlocks = []
    },
    dateCell(block, date) {
      return block && block.dates && block.dates[date] ? block.dates[date] : {}
    },
    periodLabel(block) {
      const period = block && (block.period || (block.history && block.history.period))
      return period ? period + '日ROI | 倍率' : '周期ROI | 倍率'
    },
    formatMoney(value) {
      if (this.isBlank(value)) {
        return '-'
      }
      const numberValue = Number(value)
      return Number.isNaN(numberValue) ? '-' : numberValue.toFixed(2)
    },
    formatPercent(value) {
      if (this.isBlank(value)) {
        return '-'
      }
      const numberValue = Number(value)
      return Number.isNaN(numberValue) ? '-' : (numberValue * 100).toFixed(2) + '%'
    },
    formatRate(value) {
      if (this.isBlank(value)) {
        return '-'
      }
      const numberValue = Number(value)
      return Number.isNaN(numberValue) ? '-' : numberValue.toFixed(2)
    },
    formatRoiRate(roi, rate) {
      const roiText = this.formatPercent(roi)
      const rateText = this.formatRate(rate)
      if (roiText === '-' && rateText === '-') {
        return '-'
      }
      return roiText + ' | ' + rateText
    },
    hasRoiRate(roi, rate) {
      return this.formatPercent(roi) !== '-' || this.formatRate(rate) !== '-'
    },
    compareClass(value, historyValue) {
      if (this.isBlank(value) || this.isBlank(historyValue)) {
        return ''
      }
      const numberValue = Number(value)
      const numberHistoryValue = Number(historyValue)
      if (Number.isNaN(numberValue) || Number.isNaN(numberHistoryValue)) {
        return ''
      }
      return numberValue < numberHistoryValue ? 'lower-than-history' : ''
    },
    valueClass(value, historyValue, date, period) {
      const classes = []
      const compareClass = this.compareClass(value, historyValue)
      if (compareClass) {
        classes.push(compareClass)
      }
      if (this.isEstimatedValue(date, period)) {
        classes.push('estimated-value')
      }
      return classes
    },
    isEstimatedValue(date, period) {
      if (this.activeTab !== 'estimated' || this.isBlank(period) || !this.calcDate || !date) {
        return false
      }
      const calcTime = new Date(this.calcDate + 'T00:00:00').getTime()
      const dateTime = new Date(date + 'T00:00:00').getTime()
      if (Number.isNaN(calcTime) || Number.isNaN(dateTime)) {
        return false
      }
      const diffDays = Math.floor((calcTime - dateTime) / 86400000)
      return diffDays >= 0 && diffDays < Number(period)
    },
    isBlank(value) {
      if (value === null || value === undefined || value === '') {
        return true
      }
      const numberValue = Number(value)
      return !Number.isNaN(numberValue) && numberValue === 0
    },
    displayDate(date) {
      if (!date) {
        return '-'
      }
      const parts = date.split('-')
      if (parts.length !== 3) {
        return date
      }
      return Number(parts[1]) + '/' + Number(parts[2])
    },
    defaultCalcDate() {
      const date = new Date()
      date.setDate(date.getDate() - 1)
      return this.formatDate(date)
    },
    buildDisplayDates(calcDate) {
      const dates = []
      const base = new Date(calcDate)
      for (let i = 1; i <= 9; i++) {
        const date = new Date(base)
        date.setDate(base.getDate() - i)
        dates.push(this.formatDate(date))
      }
      return dates
    },
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return year + '-' + month + '-' + day
    }
  }
}
</script>

<style scoped>
.y4-history-page {
  min-height: 100vh;
  padding: 18px;
  background: #f5f7fb;
  color: #20242a;
  box-sizing: border-box;
}

.page-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.page-toolbar h2 {
  margin: 0;
  font-size: 21px;
  font-weight: 600;
}

.page-toolbar span {
  display: inline-block;
  margin-top: 4px;
  color: #70757d;
  font-size: 12px;
}

.query-section,
.matrix-section {
  background: #ffffff;
  border: 1px solid #dfe5ec;
  border-radius: 6px;
}

.query-section {
  padding: 12px 14px;
  margin-bottom: 12px;
}

.query-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.field-label {
  color: #38404a;
  font-size: 13px;
}

.matrix-tabs {
  margin-top: 4px;
}

.matrix-section {
  min-height: 360px;
  padding: 10px;
}

.matrix-scroll {
  width: 100%;
  overflow: auto;
}

.history-table {
  min-width: 1180px;
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 12px;
  color: #2f3540;
}

.history-table td {
  height: 27px;
  padding: 3px 6px;
  border: 1px solid #2f3540;
  text-align: center;
  background: #ffffff;
  white-space: nowrap;
}

.history-table .game-cell {
  width: 130px;
  background: #ffffff;
  font-weight: 600;
}

.history-table .target-cell {
  width: 110px;
  background: #ffffff;
}

.history-table .history-head,
.history-table .history-value {
  width: 130px;
}

.history-table .date-head {
  background: #ffffff;
  font-weight: 500;
}

.history-table .metric-label {
  background: #ffffff;
  font-weight: 500;
}

.history-table .lower-than-history {
  color: #18a058;
}

.history-table .estimated-value {
  color: #1f7ae0;
}

.game-block::after {
  content: "";
  display: table-row;
  height: 24px;
}

.game-block + .game-block tr:first-child td {
  border-top-width: 2px;
}

.empty-state {
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8a93a3;
  font-size: 13px;
}
</style>
